<template>
  <div :class="'col col-xs-12 col-sm-'+colSpan+' col=md-'+colSpan+' col-lg-'+colSpan">
    <div class="row">
      <q-table
        v-if="supplierList"
        title="供應商列表"
        :data="supplierList"
        :columns="columns"
        row-key="name"
        class="full-width full-height"
      >
        <template v-slot:top-right="props">
          <q-btn
            v-if="canEdit"
            color="green"
            icon="add"
            @click="showSupplier=true"
          ></q-btn>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="title" :props="props">
              {{ props.row.suppliers.title }}
            </q-td>
            <q-td key="rate" :props="props">
              {{ props.row.suppliers.rate }}
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <q-dialog v-model="showSupplier" full-height full-width>
      <q-card style="width: 700px; max-width: 80vw;">
        <div class="q-pa-xs">
          <div class="text-h6">添加 [{{ productDetail.title }}] 供應商</div>
          <q-table
            :data="canSelectSupplier"
            :columns="columnsSelect"
            row-key="name"
            :pagination.sync="tabelSet"
          >
            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td key="title" :props="props">
                  {{ props.row.title }}
                </q-td>
                <q-td key="rate" :props="props">
                  {{ props.row.rate_detail.rate }}
                </q-td>
                <q-td key="action" :props="props">
                  <q-btn
                    v-if="canEdit"
                    color="green"
                    icon="add"
                    @click="handleAddOneProduct(props.row)"
                  ></q-btn>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: "CompanyList",
    props: {
      colSpan: {
        type: Number,
        default: 6
      },
      canEdit: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        canSelectSupplier: [],
        selectedSupplier: [],
        showSupplier: false,
        columns: [
          { name: 'title', align: 'center', label: '供應商名稱', field: 'title' },
          { name: 'rate', align: 'center', label: '評價', field: 'rate', sortable: true },
        ],
        columnsSelect: [
          { name: 'title', align: 'center', label: '供應商名稱', field: 'title' },
          { name: 'rate', align: 'center', label: '評價', field: 'rate' },
          { name: 'action', label: '操作', align: 'center', field: 'id'}
        ],
        tabelSet: {
          sortBy: 'desc',
          descending: false,
          page: 1,
          rowsPerPage: 10
        }
      }
    },
    computed: {
      ...mapGetters(['supplierList', 'productDetail'])
    },
    created(){
      this.handleCreateGetSupplierProduct()
    },
    methods: {
      handleCreateGetSupplierProduct() {
        this.$store.dispatch('supplierGetListByProductID',this.$route.params.id).then(res => {
          res.map(s =>{
            this.selectedSupplier.push(s.supplier_id)
          })
          this.handleGetCanSelectList() 
        })
      },
      handleGetCanSelectList() {
        this.$store.dispatch('supplierGetListNotSelected',{ supplier: this.selectedSupplier })
          .then(res => {
            this.canSelectSupplier = res
          })
      },
      handleAddOneProduct(supplier) {
        this.$q.dialog({
          dark: true,
          title: '確認！',
          message: '是否確認增加此供應商？',
          cancel: true,
          persistent: true
        }).onOk(() => {
          this.$store.dispatch('supplierAddOneProduct',{ supplier: supplier.id, product: this.productDetail.id })
            .then(res => {
              if (res.Answer){
                this.handleCreateGetSupplierProduct()
              }
            })
        })
      }
    }
  }
</script>

<style scoped>

</style>
